import script from "./Btn.vue?vue&type=script&lang=ts&setup=true"
export * from "./Btn.vue?vue&type=script&lang=ts&setup=true"

import "./Btn.vue?vue&type=style&index=0&id=2e8b5f24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8b5f24"]])

export default __exports__